import React from "react";
import "./index.css";
import "./global";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import ReactDOM from "react-dom/client";
import App from "./App";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
   <React.StrictMode>

    <App />
    <ToastContainer position="top-right" style={{ marginTop: "90px" }} />

</React.StrictMode>
);
